import {
  AssignIvyMerchantIntroducerRequest,
  AssignIvyMerchantIntroducerResponse,
} from "@services/models/IvyAffiliate/AssignIvyMerchantIntroducerModel";
import { GetIvyAffiliateMerchantsResponse } from "@services/models/IvyAffiliate/GetIvyAffiliateMerchantsModel";
import { GetIvyAffiliatesResponse } from "@services/models/IvyAffiliate/GetIvyAffiliatesModel";
import {
  GetIvyMerchantIntroducersRequest,
  GetIvyMerchantIntroducersResponse,
} from "@services/models/IvyAffiliate/GetIvyMerchantIntroducersModel";
import { createApiClient } from "../api/createApiClient";
import { AxiosInstance } from "axios";

class IvyAffiliateApiService {
  private api: AxiosInstance;

  constructor() {
    this.api = createApiClient();
  }

  public async getIvyAffiliates(): Promise<GetIvyAffiliatesResponse> {
    const response = await this.api.get<GetIvyAffiliatesResponse>(
      "/adminPanel/ivy/affiliates",
    );
    return response.data;
  }

  public async getIvyAffiliateMerchants(
    userId: number,
  ): Promise<GetIvyAffiliateMerchantsResponse> {
    const response = await this.api.get<GetIvyAffiliateMerchantsResponse>(
      `/adminPanel/ivy/affiliate/${userId}/merchants`,
    );
    return response.data;
  }

  public async getIvyMerchantIntroducers(
    data: GetIvyMerchantIntroducersRequest,
  ): Promise<GetIvyMerchantIntroducersResponse> {
    const response = await this.api.post<GetIvyMerchantIntroducersResponse>(
      "/adminPanel/getIvyMerchantIntroducers",
      data,
    );
    return response.data;
  }

  public async assignIvyMerchantIntroducer(
    data: AssignIvyMerchantIntroducerRequest,
  ): Promise<AssignIvyMerchantIntroducerResponse> {
    const response = await this.api.post<AssignIvyMerchantIntroducerResponse>(
      "/adminPanel/assignIvyMerchantIntroducer",
      data,
    );
    return response.data;
  }
}

export const ivyAffiliateApis = new IvyAffiliateApiService();
